/**
 * @generated SignedSource<<bbe1d9ebf9f3782d3960357762b737d7>>
 * @relayHash 9ada1bd7b0c9bc76250fb7fc68976039
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e2809ed2f9168b57b96207f5835c22774df94d5f35dcdd7653de173bcf5109a2

import type { ConcreteRequest, Query } from 'relay-runtime';
export type ConfluenceContentAccessRequestStatus = "APPROVE" | "DENY" | "PENDING" | "PENDING_SITE_APPROVAL" | "%future added value";
export type ResourceAccessType = "EDIT" | "VIEW" | "%future added value";
export type useAccessRequestsQuery$variables = {
  after?: string | null | undefined;
  cloudId: string;
  contentId: string;
  first?: number | null | undefined;
  status?: ConfluenceContentAccessRequestStatus | null | undefined;
};
export type useAccessRequestsQuery$data = {
  readonly confluence_contentAccessRequestByStatus: {
    readonly nodes: ReadonlyArray<{
      readonly accessRequestedAaid: string;
      readonly creationDateTimestamp: AGG$Long | null | undefined;
      readonly id: string;
      readonly requestAccessType: ResourceAccessType;
      readonly status: ConfluenceContentAccessRequestStatus;
      readonly user: {
        readonly displayName: string | null | undefined;
        readonly emails: ReadonlyArray<{
          readonly isPrimary: boolean | null | undefined;
          readonly value: string | null | undefined;
        } | null | undefined> | null | undefined;
        readonly id: string | null | undefined;
        readonly photos: ReadonlyArray<{
          readonly isPrimary: boolean | null | undefined;
          readonly value: string | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
    } | null | undefined>;
    readonly pageInfo: {
      readonly endCursor: string | null | undefined;
      readonly hasNextPage: boolean;
      readonly startCursor: string | null | undefined;
    };
  } | null | undefined;
};
export type useAccessRequestsQuery = {
  response: useAccessRequestsQuery$data;
  variables: useAccessRequestsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  },
  {
    "defaultValue": 10,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": "PENDING",
    "kind": "LocalArgument",
    "name": "status"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = [
  {
    "kind": "ScalarField",
    "name": "isPrimary"
  },
  {
    "kind": "ScalarField",
    "name": "value"
  }
],
v3 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "after",
        "variableName": "after"
      },
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
      },
      {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
      },
      {
        "kind": "Variable",
        "name": "status",
        "variableName": "status"
      }
    ],
    "concreteType": "ConfluenceContentAccessRequestConnection",
    "kind": "LinkedField",
    "name": "confluence_contentAccessRequestByStatus",
    "plural": false,
    "selections": [
      {
        "concreteType": "ConfluenceContentAccessRequest",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "ScalarField",
                "name": "displayName"
              },
              {
                "concreteType": "AtlassianUserEmail",
                "kind": "LinkedField",
                "name": "emails",
                "plural": true,
                "selections": (v2/*: any*/)
              },
              {
                "concreteType": "AtlassianUserPhoto",
                "kind": "LinkedField",
                "name": "photos",
                "plural": true,
                "selections": (v2/*: any*/)
              }
            ]
          },
          {
            "kind": "ScalarField",
            "name": "creationDateTimestamp"
          },
          {
            "kind": "ScalarField",
            "name": "accessRequestedAaid"
          },
          {
            "kind": "ScalarField",
            "name": "requestAccessType"
          },
          {
            "kind": "ScalarField",
            "name": "status"
          }
        ]
      },
      {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "endCursor"
          },
          {
            "kind": "ScalarField",
            "name": "hasNextPage"
          },
          {
            "kind": "ScalarField",
            "name": "startCursor"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useAccessRequestsQuery",
    "selections": (v3/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useAccessRequestsQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "9ada1bd7b0c9bc76250fb7fc68976039",
    "id": "e2809ed2f9168b57b96207f5835c22774df94d5f35dcdd7653de173bcf5109a2",
    "metadata": {},
    "name": "useAccessRequestsQuery",
    "operationKind": "query",
    "text": "query useAccessRequestsQuery($after:String,$cloudId:ID!,$contentId:ID!,$first:Int=10,$status:ConfluenceContentAccessRequestStatus=PENDING){confluence_contentAccessRequestByStatus(after:$after,cloudId:$cloudId,contentId:$contentId,first:$first,status:$status){nodes{id,user{id,displayName,emails{isPrimary,value},photos{isPrimary,value}},creationDateTimestamp,accessRequestedAaid,requestAccessType,status},pageInfo{endCursor,hasNextPage,startCursor}}}"
  }
};
})();

(node as any).hash = "576bef7477d804a68ae0b5eb3d4f4d59";

export default node;
